import React, { useEffect, useState } from 'react';
import { FeatureTogglesProvider } from '../featureToggles/FeatureTogglesProvider';
import { useDrupalFeatureToggles } from '../featureToggles/useDrupalFeatureToggles';
import { LayoutContextProvider } from '../providers/LayoutProvider';
import { SearchContextProvider } from '../providers/SearchProvider';

// Used as wrapRootElement by both gatsby-ssr and gatsby-browser, so the static
// build and client hydration render the same provider tree.
export default ({ element }) => {
    return (
        <FeatureToggles>
            <Inner>{element}</Inner>
        </FeatureToggles>
    );
};

// Gatsby calls wrapRootElement as a plain function, so the static query for the
// Drupal Feature Flags terms runs in this component instead.
const FeatureToggles = ({ children }) => {
    const drupalToggles = useDrupalFeatureToggles();
    return (
        <FeatureTogglesProvider drupalToggles={drupalToggles}>
            {children}
        </FeatureTogglesProvider>
    );
};

const Inner = ({ children }) => {
    const [darkNavigationTheme, setDarkNavigationTheme] = useState(false);
    const [navigationSelect, setNavigationSelect] = useState(null);
    const [inlineAnchor, setInlineAnchor] = useState<string>(``);
    const [anchorTagEls, setAnchorTagEls] = useState<HTMLAnchorElement[]>(null);
    const [headerRef, setHeaderRef] = useState<HTMLHeadElement>(null);
    const [contactFormID, setContactFormID] = useState<HTMLElement>(null);
    const [sidebarExpanded, setSidebarExpanded] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const [currentSubmenu, setCurrentSubmenu] = useState(``);
    const [quizResults, setQuizResults] = useState<{
        [key: string]: string | number | boolean;
    }>(null);
    const [urlParams, setUrlParams] = useState(``);
    const [nodeLookup, setNodeLookup] = useState<
        { nodeId: number; path: string }[]
    >([]);
    const [inputProspect, setInputProspect] = useState({});
    const [campaignTermsFilter, setCampaignTermsFilter] = useState([]);
    const [customCTA, setCustomCTA] = useState<{ title: string; uri: string }>({
        title: ``,
        uri: ``,
    });

    useEffect(() => {
        try {
            const savedResults = localStorage.getItem(`quizResults`);
            if (savedResults) {
                const json = JSON.parse(savedResults);
                setQuizResults(json);
            } else {
                setQuizResults({ none: true });
            }
        } catch {
            console.warn(`Unable to retrieve quiz results.`);
            setQuizResults({ none: true });
        }
    }, []);

    return (
        <LayoutContextProvider
            value={{
                darkNavigationTheme,
                setDarkNavigationTheme,
                sidebarExpanded,
                setSidebarExpanded,
                currentSubmenu,
                setCurrentSubmenu,
                quizResults,
                setQuizResults,
                urlParams,
                setUrlParams,
                nodeLookup,
                setNodeLookup,
                searchOpen,
                setSearchOpen,
                inlineAnchor,
                setInlineAnchor,
                anchorTagEls,
                setAnchorTagEls,
                inputProspect,
                setInputProspect,
                campaignTermsFilter,
                setCampaignTermsFilter,
                customCTA,
                setCustomCTA,
                contactFormID,
                setContactFormID,
                headerRef,
                setHeaderRef,
                navigationSelect,
                setNavigationSelect,
            }}
        >
            <SearchContextProvider>{children}</SearchContextProvider>
        </LayoutContextProvider>
    );
};
